import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

const External = ({
  value,
  paramValue,
  onChange,
  onParamChange,
  onNameChange, 
  name,
  showParamInput,
  toggleItem,
  addEmbeddedStep,
  title,
}) => (
  <div style={{ padding: "0px 0px 24px", position: "relative" }}>
    <div style={{ position: "absolute", left: 16 }}>
      <Tooltip title="Back to table">
        <IconButton onClick={toggleItem} aria-label="delete" size="large">
          <ArrowBackRoundedIcon />
        </IconButton>
      </Tooltip>
    </div>

    <div
      style={{
        margin: "auto",
        width: "min(720px, 100%)",
        display: "grid",
        gap: 20,
        textAlign: "center", 
      }}
    >
      <Typography
        style={{
          paddingTop: 16,
          fontSize: 22,
          fontWeight: 600,
        }}
        component={"span"}
      >
        {title}
      </Typography>
      <div>
        <TextField
          label="Step name"
          value={name}
          onChange={onNameChange}
          variant="standard"
          fullWidth
        />
      </div>

      <div>
        <TextField
          label="Step URL"
          type="text"
          value={value}
          onChange={onChange}
          variant="standard"
          fullWidth
        />
      </div>
      {showParamInput ? (
        <div>
          <TextField
            label="Member insert param"
            type="text"
            value={paramValue}
            onChange={onParamChange}
            variant="standard"
            fullWidth
          />
        </div>
      ) : null}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          style={{ background: "#00badb", minWidth: 220 }}
          variant="contained"
          size="large"
          onClick={addEmbeddedStep}
        >
          {title}
        </Button>
      </div>
    </div>
  </div>
);

export default External;

External.propTypes = {
  value: PropTypes.string,
  paramValue: PropTypes.string,
  onChange: PropTypes.func,
  onParamChange: PropTypes.func,
  onNameChange: PropTypes.func,
  name: PropTypes.string,
  showParamInput: PropTypes.bool,
  toggleItem: PropTypes.func,
  addEmbeddedStep: PropTypes.func,
  title: PropTypes.string,
};
